
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules/upload",
      function () {
        return require("private-next-pages/rules/upload.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules/upload"])
      });
    }
  